import React from 'react';

import { connect } from 'react-redux';

import type { RootState } from '@store';

import { DisplayText, DisplayWrapper } from '../styled';

import type { DisplayProps, MapStateToProps } from './interfaces';

export class DisplayClass extends React.Component<DisplayProps> {
	render(): JSX.Element {
		const { displayValue, result } = this.props;

		return (
			<DisplayWrapper>
				<DisplayText data-test-id="display-value">{displayValue}</DisplayText>
				<DisplayText data-test-id="display-result-value">{result}</DisplayText>
			</DisplayWrapper>
		);
	}
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
	displayValue: state.calculator.displayValue,
	result: state.calculator.result,
});

export const displayConnector = connect(mapStateToProps);

export const DisplayCC = displayConnector(DisplayClass);
